import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Box, Typography, Button } from "@mui/joy";
import { Reveal } from "./Reveal";
export function CTASection() {
  return (
    <Box
      component="section"
      data-testid="cta-section"
      sx={{
        backgroundColor: "#FF5A00", // bg-safety
        color: "#111111", // text-obsidian
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px", // max-w-7xl
          mx: "auto",
          px: {
            xs: 2,
            sm: 3,
            lg: 4,
          },
          py: {
            xs: 10,
            md: 14,
          },
        }}
      >
        <Reveal>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(12, 1fr)",
              },
              gap: 4,
              alignItems: "flex-end",
            }}
          >
            {/* Left Content */}
            <Box
              sx={{
                gridColumn: {
                  md: "span 8",
                },
              }}
            >
              <Typography
                sx={{
                  mb: 3,
                  fontFamily: '"Roboto Mono", monospace',
                  fontSize: "0.875rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  textAlign: "left",
                  color: "black",
                }}
              >
                [ Talk to an engineer ]
              </Typography>

              <Typography
                component="h2"
                sx={{
                  fontFamily: "Cabinet Grotesk, system-ui, sans-serif",
                  fontWeight: 900,
                  fontSize: {
                    xs: "2.25rem",
                    md: "3.75rem",
                  },
                  lineHeight: 0.95,
                  letterSpacing: "-0.05em",
                  textAlign: "left",
                  color: "black",
                }}
              >
                Specify it. We'll build it to standard.
              </Typography>
            </Box>

            {/* Right Content */}
            <Box
              sx={{
                gridColumn: {
                  md: "span 4",
                },
                textAlign: {
                  xs: "left",
                  md: "right",
                },
              }}
            >
              <Typography
                sx={{
                  color: "rgba(17,17,17,0.8)",
                  mb: 3,
                  maxWidth: "24rem",
                  ml: {
                    md: "auto",
                  },
                }}
              >
                Custom-engineered stabilizers, transformers and CVTs for your
                exact load, phase and site conditions.
              </Typography>

              <Button
                component={Link}
                to="/contact"
                data-testid="cta-request-quote"
                endDecorator={<ArrowRight size={16} />}
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1.5,
                  backgroundColor: "#111111",
                  color: "#FFFFFF",
                  px: 4,
                  py: 2,
                  borderRadius: 0,
                  fontFamily: '"Roboto Mono", monospace',
                  fontWeight: 600,
                  textTransform: "none",
                  transition: "all 0.3s ease",

                  "&:hover": {
                    backgroundColor: "#111111",
                    gap: 2.5,
                  },
                }}
              >
                Request a Quote
              </Button>
            </Box>
          </Box>
        </Reveal>
      </Box>
    </Box>
  );
}
